import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';
import { TicketStatus } from 'src/store/models/Ticket';
import { colors } from 'src/utils/colors';

import classes from './StatusIndicator.module.scss';

export interface StatusIndicatorProps {
  status: TicketStatus;
}

const StatusIndicator: FC<StatusIndicatorProps> = ({ status }) => {
  const { t } = useTranslation();

  const user = useAppSelector((state) => state.auth.user);
  const isService = user?.role === Role.SERVICE;
  const isManufacturer = user?.role === Role.MANUFACTURER;

  const statusColor =
    status === TicketStatus.TO_DO && isManufacturer
      ? colors()?.colorBlack
      : (status === TicketStatus.TO_DO && isService) ||
        (status === TicketStatus.UNASSIGNED && isManufacturer)
      ? colors()?.colorRed
      : status === TicketStatus.IN_PROGRESS
      ? colors()?.colorYellow
      : colors()?.colorFumisGreen1;

  const label =
    status === TicketStatus.TO_DO
      ? t(`common:assigned`)
      : t(`common:${status}`);

  return (
    <div className={classes.Container}>
      <div style={{ backgroundColor: statusColor }} />
      <p>{label}</p>
    </div>
  );
};

export default StatusIndicator;
